import {$host} from './index';
import {YANDEX_WAREHOUSE_PICKUP} from './ApiEndpoints';

/**
 * ID точки отгрузки для source_platform_station в виджете (бэкенд дергает API 2.02).
 * @returns {Promise<{ pickupPointId: string, name?: string, fullAddress?: string, fromApi: boolean }>}
 */
export const fetchWarehousePickupPoint = async () => {
    const {data} = await $host.get(YANDEX_WAREHOUSE_PICKUP);
    return data;
};
